import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { WmsGlobalMeta } from './components/global-meta/global-meta';

@Component({
	components: {
		WmsGlobalMeta
	}
})
export class App extends Vue {
	mounted() {
		this.$store.init();
	}
}


export default App;
